export const releases = {
  actions: {
    continueReading: "Continue Reading",
    startReading: "Start Reading",
    buyNow: "Buy Now",
    preview: "Preview",
    freeWithGold: "Free with Gold",
    freeWithGoldDigital: "Free with Gold - Digital",
    getGold: "Get Gold",
    purchaseOptions: "Purchase Options",
    printEdition: "Print Edition",
    buyPrint: "Buy Print",
  },
};
